import { render, staticRenderFns } from "./NonAuthLogoBlock.vue?vue&type=template&id=25ef7eae&scoped=true&"
import script from "./NonAuthLogoBlock.vue?vue&type=script&lang=js&"
export * from "./NonAuthLogoBlock.vue?vue&type=script&lang=js&"
import style0 from "./NonAuthLogoBlock.vue?vue&type=style&index=0&id=25ef7eae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef7eae",
  null
  
)

export default component.exports